import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import formatter from '../../utilities/formatter';
import postData from '../../utilities/postData';
import PropTypes from 'prop-types';
import useBreakpoints from '../../utilities/useBreakpoints';

const JobItem = (props) => {
    const { item } = props;
    const { isBreakpoint } = useBreakpoints();

    const deleteUrl = `/api/jobs/delete/${item.id}`;

    function deleteItem() {
        postData(deleteUrl, null, () => {
            props.fetchData();
            window.dispatchEvent(new Event('updateChangeLog'));
        });
    }

    return (
        <tr>
            <CustomTd content={item.jobNumber} />
            <CustomTd style={{ textWrap: 'balance'}} content={formatter.dateTimePretty(item.installationDate)} />
            <CustomTd content={formatter.currency(item.total)} />
            <CustomTd hide="md" content={formatter.currency(item.deposit)} />
            <CustomTd hide="sm" content={formatter.currency(item.balance)} />
            <CustomTd hide="md" content={item.paid} />

            <CustomTd className="button-cell">
                <EditDeleteButton
                    showText={false}
                    viewItem={props.editItem}
                    editItem={props.editItem}
                    deleteItem={deleteItem}
                    acl={item.acl}
                />
            </CustomTd>
        </tr>
    );
}

JobItem.propTypes = {
    deleteUrl: PropTypes.string,
    editItem: PropTypes.func,
    fetchData: PropTypes.func
};

export default JobItem;